import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { useFlags } from '@atlaskit/flag';
import CheckIcon from '@atlaskit/icon/core/check-mark';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';

const i18nFlags = defineMessages({
	successTitle: {
		id: 'team-admin-controls.flag.success.title',
		defaultMessage: 'Settings saved',
		description: 'Title for the success flag shown when team admin controls settings are saved',
	},
	errorTitle: {
		id: 'team-admin-controls.flag.error.title',
		defaultMessage: 'Error',
		description: 'Title for the error flag shown when saving team admin controls settings fails',
	},
	errorDescription: {
		id: 'team-admin-controls.flag.error.description',
		defaultMessage: 'Something went wrong. Please try again.',
		description: 'The text is shown as the body description in an error flag notification when saving team admin controls settings fails. It prompts the user to try the action again.',
	},
});

export const useAdminControlsFlags = () => {
	const { showFlag } = useFlags();
	const { formatMessage } = useIntl();
	const showSuccessFlag = () => {
		void showFlag({
			id: `team-admin-controls-success-${Date.now()}`,
			title: formatMessage(i18nFlags.successTitle),
			isAutoDismiss: true,
			icon: <CheckIcon label={formatMessage(i18nFlags.successTitle)} />,
		});
	};

	const showErrorFlag = () => {
		void showFlag({
			id: `team-admin-controls-error-${Date.now()}`,
			title: formatMessage(i18nFlags.errorTitle),
			description: formatMessage(i18nFlags.errorDescription),
			isAutoDismiss: true,
			icon: <StatusErrorIcon label={formatMessage(i18nFlags.errorTitle)} />,
		});
	};
	return {
		showSuccessFlag,
		showErrorFlag,
	};
};
